<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <loader v-if="loading"/>

    <b-row>

      <b-col :md="columnWith" v-for="(input, key) in inputs" :key="key">
        <label :for="input.name">{{input.label}}<span class="text-danger">{{$t('form.required_star')}}</span></label>
        <div class="mb-4">
          <b-form-input
            v-model="params[input.name]"
            :placeholder="input.placeholder"
            :name="input.name"
            :id="input.name"
            @input="value => {createParamsObject(input.name, value)}"
          />
          <span class="text-danger position-absolute error"
                v-if="!$v[input.name].required && $v[input.name].$dirty">
            {{$t('form.required_field')}}
          </span>
        </div>
      </b-col>

    </b-row>

    <b-row>

      <b-col md="3" v-for="(input, key) in selects" :key="input.name + key">
        <label :for="input.name">{{input.label}}<span class="text-danger">{{$t('form.required_star')}}</span></label>
        <div class="mb-4">
          <multiselect
            v-model="params[input.name]"
            :searchable="input.searchable"
            :multiple="false"
            :id="input.name"
            label="label"
            track-by="label"
            :options="input.options"
            :allow-empty="false"
            :taggable="false"
            :close-on-select="!input.multiple"
            @input="value => {createParamsObject(input.name, value.value)}"
            select-label=""
            selected-label=""
            deselect-label="X "
            tag-placeholder="+">
            <template slot="noResult">
              {{$t('global.no_results')}}
            </template>
          </multiselect>
        </div>
      </b-col>

      <b-col md="3" v-if="editing">
        <label for="slug">{{$t('form.slug')}}</label>
        <div class="mb-4">
          <b-form-input
            disabled
            v-model="params.slug"
            :placeholder="$t('form.slug_placeholder')"
            name="slug"
            id="slug"
            @input="value => {createParamsObject('slug', value)}"
          />
        </div>
      </b-col>

      <b-col
        md="3"
        v-for="(input, index) in checkboxes"
        :key="`${index}${input.name}`"
        class="justify-content-center d-flex flex-column"
      >
        <b-form-checkbox
          v-model="params[input.name]"
          @input="value => {createParamsObject(input.name, value)}"
        > {{input.label}}
        </b-form-checkbox>
      </b-col>

    </b-row>

    <b-row class="mb-5">

      <b-col>
        <b-tabs>
          <b-tab
            :title="input.label"
            v-for="(input, index) in editors"
            :key="index">
            <editor
              v-model="params[input.name]"
              :lang="input.lang" theme="chrome" width="100%" height="600"
              @init="editorInit"
              @input="value => {createParamsObject(input.name, value)}"
            ></editor>
          </b-tab>
        </b-tabs>
      </b-col>

    </b-row>


    <form-buttons @submit="debounceSubmit" v-if="showButtons"></form-buttons>

  </div>
</template>

<script>
  import {filter, debounce, capitalize} from 'lodash';
  import {required} from "vuelidate/lib/validators";

  export default {
    name: 'TemplateView',
    middleware: 'auth',
    props: {
      fields: {
        type: Array,
        require: true
      },
      editing: {
        type: Boolean,
        default: false
      },
      columnWith: {
        type: Number,
        default: 4
      },
      showButtons: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        prefillParams: {},
        loading: false,
        name: '',
        title: '',
        version: '',
        params: {
          name: '',
          title: '',
          version: '',
          template: '',
          css: '',
          javascript: ''
        },
        paramsMutated: {},
        debounceSubmit: () => {}
      }
    },
    validations: {
      name: {
        required
      },
      title: {
        required
      },
      version: {
        required
      }
    },
    created () {
      window.addEventListener("keydown", this.saveWithHotkey );
    },
    destroyed() {
      window.removeEventListener("keydown", this.saveWithHotkey );
    },
    mounted() {
      if (this.editing) {
        this.getData(`popup-templates/${this.$route.params.id}`, null, true)
          .then(({data}) => {
            this.prefillParams = data;
            this.setPrefillData(this.prefillParams);
          })
      }
      this.debounceSubmit = debounce(this.submit, 1000);
    },
    computed: {
      inputs() {
        return filter(this.fields, input => input.type === 'text');
      },
      selects() {
        return filter(this.fields, input => input.type === 'select');
      },
      checkboxes() {
        return filter(this.fields, input => input.type === 'checkbox');
      },
      editors() {
        return filter(this.fields, input => input.type === 'editor');
      }
    },
    methods: {
      saveWithHotkey (e) {
        if ((window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) && (e.key === 's' || e.key === 'S')) {
          e.preventDefault();
          this.debounceSubmit();
        }
      },
      editorInit() {
        require('brace/mode/html');
        require('brace/mode/css');
        require('brace/mode/javascript');
        require('brace/theme/chrome')
      },
      createParamsObject(name, value) {
        this.paramsMutated[name] = value;
      },
      setPrefillData(prefill) {
        this.params = prefill;
        this.params.required_auth = prefill.settings.required.auth;
        this.params.status = {label: capitalize(prefill.status), value: prefill.status};
        this.params.template = decodeURIComponent(prefill.template);
        this.params.css = decodeURIComponent(prefill.css);
        this.params.javascript = decodeURIComponent(prefill.javascript);
      },
      submit() {
        this.name = this.params.name;
        this.title = this.params.title;
        this.version = this.params.version;

        this.$v.$touch();
        if (this.$v.$invalid) {
          if (!this.status) {
            this.$noty.error('No status data');
            return;
          }
          return;
        }
        if (!_.isEmpty(this.prefillParams)) {
          this.putData(`popup-templates/${this.prefillParams.uid}`, this.paramsMutated)
        } else {
          this.postData('popup-templates', this.paramsMutated, '/templates')
        }
      }
    }
  }
</script>
